/* eslint-disable */
// THIS FILE IS REQUIRED FOR WEBPACK BUNDLING. IT HELPS TO INCLUDE ./components/** into the sync module 'main.js'

import CliLoader from 'components/CliLoader';
import Form, { Field } from '@ohmsd/v-form';
import Fetch from 'components/Fetch';
// import Chart from '@ohmsd/v-chart/Chart';
import Table from 'components/Table';
import BarLoader from 'components/BarLoader';
/* eslint-enable */

import './mixins';
